module.exports = __webpack_public_path__ + "img/green-card.5874a4dc.svg";